<template>
    <div v-if="usage" class="plan-usage-panel">
        <common-page-header
            :heading="$t('pages.practice.billing.usage.heading')"
            size="page-plain-header"
            contentSpacing="medium"
        ></common-page-header>
        <div class="plan-usage-panel__grid">
            <div class="plan-usage-panel__item">
                <span class="plan-usage-panel__label">{{ billableLabel }}</span>
                <span class="plan-usage-panel__value">
                    {{ formatUsedIncluded(usage.billableUnitsUsed, usage.billableUnitsIncluded) }}
                </span>
            </div>
            <div class="plan-usage-panel__item">
                <span class="plan-usage-panel__label">{{ $t('pages.practice.billing.usage.referrals') }}</span>
                <span class="plan-usage-panel__value">
                    {{ formatUsedIncluded(usage.referralsUsed, usage.referralsIncluded) }}
                </span>
            </div>
            <div v-if="usage.referralCostEstimate != null" class="plan-usage-panel__item">
                <span class="plan-usage-panel__label">{{ $t('pages.practice.billing.usage.referral_estimate') }}</span>
                <span class="plan-usage-panel__value">${{ usage.referralCostEstimate }}</span>
            </div>
            <div v-if="usage.nextInvoiceAmountDue != null" class="plan-usage-panel__item">
                <span class="plan-usage-panel__label">{{ $t('pages.practice.billing.usage.next_invoice') }}</span>
                <span class="plan-usage-panel__value">${{ usage.nextInvoiceAmountDue }}</span>
            </div>
            <div v-if="periodEnd" class="plan-usage-panel__item">
                <span class="plan-usage-panel__label">{{ $t('pages.practice.billing.usage.period_end') }}</span>
                <span class="plan-usage-panel__value">{{ periodEnd }}</span>
            </div>
        </div>
    </div>
</template>

<script>
    import dayjs from 'dayjs'

    export default {
        props: {
            usage: { type: Object, default: null },
        },

        computed: {
            billableLabel() {
                if (this.usage?.billableUnit === 'LOCATION') {
                    return this.$t('pages.practice.billing.usage.locations')
                }
                return this.$t('pages.practice.billing.usage.seats')
            },
            periodEnd() {
                const end = this.usage?.currentPeriodEnd
                return end ? dayjs(end).format('MMM DD YYYY') : null
            },
        },

        methods: {
            formatUsedIncluded(used, included) {
                const usedVal = used == null ? 0 : used
                if (included == null) {
                    return `${usedVal} / Unlimited`
                }
                return `${usedVal} / ${included}`
            },
        },
    }
</script>

<style scoped lang="scss">
    @import 'styles/setup/_variables.scss';

    .plan-usage-panel {
        background: $color--bg-dashboard;
        border-radius: 8px;
        padding: 16px;
        margin-bottom: 20px;

        &__grid {
            display: grid;
            grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));
            gap: 12px;
        }

        &__item {
            display: flex;
            flex-direction: column;
            gap: 4px;
        }

        &__label {
            font-size: 12px;
            color: #4f4f4f;
            font-weight: 500;
        }

        &__value {
            font-size: 16px;
            font-weight: 600;
            color: #001d50;
        }
    }
</style>
